import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface GoalPrioritizationMatrixTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const GoalPrioritizationMatrixTour: React.FC<GoalPrioritizationMatrixTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.goal_prioritization_matrix.welcome.title')}
                    </h3>
                    <p>{t('app_tour.goal_prioritization_matrix.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="add-goal-form"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.goal_prioritization_matrix.add_goal_form.title')}
                    </h3>
                    <p>{t('app_tour.goal_prioritization_matrix.add_goal_form.description')}</p>
                </div>
            ),
            placement: 'bottom',
            spotlightClicks: false,
        },
        {
            target: '[data-tour="goal-distribution-chart"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.goal_prioritization_matrix.goal_distribution_chart.title')}
                    </h3>
                    <p>{t('app_tour.goal_prioritization_matrix.goal_distribution_chart.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="goals-table"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.goal_prioritization_matrix.goals_table.title')}
                    </h3>
                    <p>{t('app_tour.goal_prioritization_matrix.goals_table.description')}</p>
                </div>
            ),
            placement: 'top',
        },
    ];


    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="goal-prioritization-matrix" steps={steps} navigateTo="/dashboard/tools/goal-prioritization-matrix" />;
};

export default GoalPrioritizationMatrixTour;

